<div class="pa-input">
  <label *ngIf="label" class="line-label" [for]="valueAccessor.inputId">
    <span class="required-asterisk" *ngIf="isRequired">
      <i class="pi pi-asterisk" style="font-size: 10px"></i>
    </span>
    <span class="label-text">{{ label }}</span>
    <i *ngIf="tooltip" class="pi pi-question-circle" [pTooltip]="tooltip" hideDelay="300"></i>
  </label>

  <div class="range-row">
    <pa-button
      icon="pi pi-chevron-left"
      severity="secondary"
      variant="text"
      [disabled]="!canShift"
      (click)="handleShift(-1)"
    ></pa-button>

    <div class="range-picker">
      <pa-datepicker-range
        [formControl]="innerControl"
        dataType="date"
        [customErrorMessages]="customErrorMessages"
        [placeholder]="placeholder"
      ></pa-datepicker-range>
    </div>

    <pa-button
      icon="pi pi-chevron-right"
      severity="secondary"
      variant="text"
      [disabled]="!canShift"
      (click)="handleShift(1)"
    ></pa-button>
  </div>

  <div class="period-picker">
    <pa-button
      *ngFor="let option of resolvedPeriodOptions"
      [label]="option.name"
      size="small"
      [severity]="'secondary'"
      [variant]="periodControl.value === '' + option.id ? undefined : 'outlined'"
      (click)="handlePeriodSelect(option.id)"
    ></pa-button>
  </div>

  <small *ngIf="hint" class="hint">{{ hint }}</small>
</div>

